(function() {
  const handleCartAgreement = () => {
    const checkbox = document.getElementById("acceptance");
    const button = document.querySelector(".cart__summary-button");
    const note = document.querySelector(".cart-footer-aggrements-note");

    if (!checkbox || !button) return;

    const updateUI = () => {
      const isChecked = checkbox.checked;

      if (isChecked) {
        button.classList.remove("cart-recap-btn--disabled");
        button.disabled = false;
        button.style.pointerEvents = "auto";
        button.style.opacity = "1";
        if (note) note.style.display = "none";
      } else {
        button.classList.add("cart-recap-btn--disabled");
        button.disabled = true;
        button.style.pointerEvents = "none";
        button.style.opacity = "0.5";
        if (note) note.style.display = "block";
      }
    };

    // Event listener
    checkbox.addEventListener("change", updateUI);
    updateUI();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", handleCartAgreement);
  } else {
    handleCartAgreement();
  }

  document.addEventListener("shopify:section:load", handleCartAgreement);
})();